import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios, { AxiosError } from "axios";
import { buildStaffResourcePathForCurrentUser } from "../ResourceBuilder";

const labcorpApi = createApi({
    reducerPath: "lobbie/integrations/labcorp",
    baseQuery: fetchBaseQuery({}),
    endpoints: (builder) => ({
        getAccudrawAccountZips: builder.query<string, number>({
            queryFn: async (locationId) => {
                const fetchUrl = buildStaffResourcePathForCurrentUser(
                    `/labs/orders/labcorp/accudraw/account-zips/${locationId}`,
                );

                try {
                    const response = await axios.get<string>(fetchUrl, { withCredentials: true });
                    return { data: response.data };
                } catch (error) {
                    const axiosError = error as AxiosError;
                    return {
                        data: undefined,
                        error: {
                            status: axiosError.status ?? 0,
                            data: axiosError.response?.data,
                        },
                    };
                }
            },
        }),
    }),
});

export const { useGetAccudrawAccountZipsQuery, useLazyGetAccudrawAccountZipsQuery } = labcorpApi;

export default labcorpApi;
